import React, { Component } from 'react';
import {
  ArrayInput,
  DisabledInput,
  SimpleForm,
  SimpleFormIterator,
  TextInput,
  NumberInput,
  Toolbar,
  SaveButton,
  translate
} from 'react-admin';
import FieldGroup from '~components/FieldGroup';
import { isRequired } from '~utils/inputValidations';

function EtapaToolbar(props) {
  return (
    <Toolbar {...props}>
      <SaveButton />
    </Toolbar>
  );
}

class EtapaForm extends Component {
  render() {
    return (
      <SimpleForm {...this.props} toolbar={<EtapaToolbar />}>
        {this.props.children}
        <FieldGroup label="fieldGroups.etapaEs">
          <TextInput source="name" validate={isRequired} />
        </FieldGroup>
        <FieldGroup label="fieldGroups.etapaEn">
          <TextInput source="nameEn" />
        </FieldGroup>
        <FieldGroup label="fieldGroups.etapaPt">
          <TextInput source="namePt" />
        </FieldGroup>
        <FieldGroup label="fieldGroups.etapa">
          <NumberInput source="order" />
          {/* Weights must add up to 100 across etapas: edited in "Configurar pesos". */}
          <DisabledInput source="weight" />
        </FieldGroup>
        <FieldGroup label="fieldGroups.etapaSubStages">
          <ArrayInput source="subStages" label="">
            <SimpleFormIterator>
              <TextInput source="name" label="resources.etapas.fields.name" validate={isRequired} />
              <TextInput source="nameEn" label="resources.etapas.fields.nameEn" />
              <TextInput source="namePt" label="resources.etapas.fields.namePt" />
            </SimpleFormIterator>
          </ArrayInput>
        </FieldGroup>
      </SimpleForm>
    );
  }
}

export default translate(EtapaForm);
